import { UPLT_PAGE_NAMES_ENABLE_PAGE_UPDATE_FIX } from "@faire/web-api--source/indigofair/settings/UPLT_PAGE_NAMES_ENABLE_PAGE_UPDATE_FIX";

import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";

export const getSettingUPLTPageNameEnablePageUpdateFix = (): string =>
  getSettingValueWithoutAssignment(UPLT_PAGE_NAMES_ENABLE_PAGE_UPDATE_FIX, "");
